<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <span id="log"></span> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      res: {},
      shareTitel: "暖暖星球-遇见暖暖星球的你",
      shareDesc: "直播我的美  暖暖星球你的心",
      shareUrl: window.location.protocol + "//" + window.location.hostname + "/",
      head: " https://resource.imbeiyu.com/resource/logo/logo2.png",
      visit_qq: "https://www.imbeiyu.com/",
    }
  },
  created() {
    this.shareUrl = window.location.protocol + "//" + window.location.hostname + "/";
    console.log(this.shareUrl)
    let goUrl = this.isMobile();
    if (goUrl === 1) {
      //移动端地址

      var name = this.$route.name
      if (name == 'pchome' || name == 'recharge' || name == 'pcenlist' || name == 'joinus' || name == 'nnlive' || name == 'aboutus' || name == 'contactus') {
        this.$router.push({ name: 'h5home' })
      } else {
        this.$router.push({ name: name ? name : 'h5home' })
      }

    } else {
      console.log(this.$route.name)
      var name = this.$route.name
      if (name == 'h5home' || name == 'h5recharge' || name == 'h5enlist' || name == 'h5contactus' || name == 'h5aboutus') {
        this.$router.push({ name: 'pchome' })
      } else {
        this.$router.push({ name: name ? name : 'pchome' })
      }



    }
    setTimeout(() => {
      this.doConfig()
    }, 200)



  },

  methods: {

    isMobile() {
      // alert(navigator.userAgent)
      //       var ua = navigator.userAgent,
      //    isWindowsPhone = /(?:Windows Phone)/.test(ua),
      //     isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      //     isAndroid = /(?:Android)/.test(ua),
      //     isFireFox = /(?:Firefox)/.test(ua),
      //     isChrome = /(?:Chrome|CriOS)/.test(ua),
      //     isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      //     isPhone = /(?:iPhone)/.test(ua) && !isTablet,

      //  isPc = !isPhone && !isAndroid && !isSymbian
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      var flag2 = flag || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

      // console.log("navigator.userAgent")
      //  console.log(navigator)
      localStorage.setItem('isiphone', flag2)
      localStorage.setItem('ismobile', flag2 ? 1 : 0);
      // console.log(isPc)
      let goUrl = flag2 ? 1 : 0;
      return goUrl;
    },
    doConfig() {
      var _this = this
      // $.getJSON(url, {
      // 	cmd : 'wechat.baseSupport',
      // 	url : document.location.href,
      // 	type : 2
      // }, function(data) {

      // });
      _this.$http.get(_this.$api.baseSupport, {
        params: {
          url: _this.shareUrl,
        }
      }).then(function (data) {

        if (data.data.state) {
          _this.res = data.data.js;

          _this.weixinConfig()

        }

      })
    },
    weixinConfig() {
      var _this = this
      var shareLink = _this.shareUrl;  //需在用户可能点击分享按钮前就先调用
      console.log(_this.res.appId)
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: _this.res.appId, // 必填，公众号的唯一标识
        timestamp: _this.res.timestamp, // 必填，生成签名的时间戳
        nonceStr: _this.res.nonceStr, // 必填，生成签名的随机串
        signature: _this.res.signature, // 必填，签名
        jsApiList: ['onMenuShareTimeline',
          'onMenuShareAppMessage', 'onMenuShareQQ',
          'onMenuShareWeibo', 'updateTimelineShareData', 'updateAppMessageShareData']
      });
      wx.checkJsApi({
        jsApiList: ['onMenuShareTimeline',
          'onMenuShareAppMessage', 'onMenuShareQQ',
          'onMenuShareWeibo', 'updateTimelineShareData', 'updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
        }
      });
      wx.error(function (res) {
      });
      wx.ready(function () {
        // 	wx.hideMenuItems({
        // 	menuList : ['menuItem:openWithQQBrowser',
        // 		         	'menuItem:openWithSafari' ]
        // // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        // });
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        console.log(_this.shareDesc)
        wx.onMenuShareTimeline({
          title: _this.shareTitel, // 分享标题
          desc: _this.shareDesc, // 分享描述
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: _this.head, // 分享图标
          success: function () {
          },
          cancel: function (err) {
          },
          fail: function (e) {
          }
        });
        wx.onMenuShareAppMessage({
          title: _this.shareTitel, // 分享标题
          desc: _this.shareDesc, // 分享描述
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: _this.head, // 分享图标
          success: function () {
          },
          cancel: function (err) {
          },
          fail: function (e) {
          }
        });
        wx.onMenuShareQQ({
          title: _this.shareTitel, // 分享标题
          desc: _this.shareDesc, // 分享描述
          link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: _this.head, // 分享图标
          success: function () {
          },
          cancel: function (err) {
          },
          fail: function (e) {
          }
        });
      });

    },
  }
}
</script>

<style  lang="less">
// #app {
//   width: 100%; height: 100%;
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   position: relative;
//   /* margin-top: 60px; */
//   #log{
//             display: block; 
//             width: 9.2%; height: 7%; 
//             position: absolute; background: url("http://lianai-image-sys.imlianai.com/19_3_23/logo.png"); 
//             background-size: 100% 100%; left: 20%; top: 4%;
//             z-index: 2;
//         }
// }
</style>



// WEBPACK FOOTER //
// src/App.vue